// extracted by mini-css-extract-plugin
export default {"main-container":"authPage_main-container__cNHyJ","bsk-container":"authPage_bsk-container__4LSOn"};